import React, { useMemo } from "react";
import { usePricingCatalog } from "../../../../../hooks/app/usePricingCatalog";
import {
  buildStaticPricingCatalog,
  creditCostForTool,
} from "../../../../../data/pricingModal";
import { uiCreditCostForTask } from "../../../../../data/aiOperationCredits";
import { creditTaskKeyForTool } from "../../../../../utils/credits/dashboardAiCredits";

const CreditsIcon = () => (
  <svg
    className="abitp-done-credits__icon"
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
  >
    <ellipse cx="8" cy="4.5" rx="5" ry="2.2" stroke="currentColor" strokeWidth="1.3" />
    <path
      d="M3 4.5v3c0 1.2 2.2 2.2 5 2.2s5-1 5-2.2v-3"
      stroke="currentColor"
      strokeWidth="1.3"
    />
    <path
      d="M3 7.5v3c0 1.2 2.2 2.2 5 2.2s5-1 5-2.2v-3"
      stroke="currentColor"
      strokeWidth="1.3"
    />
  </svg>
);

function staticCostFor(taskKey) {
  const tools = buildStaticPricingCatalog().tools || [];
  const row = tools.find((tool) => tool.key === taskKey);
  const value = Number(creditCostForTool(row));
  return Number.isFinite(value) && value > 0 ? value : null;
}

/** Credit count shown beside Generate / Regenerate. UI schedule, then catalog, then static fallback. */
const ToolPrepCreditsBadge = ({ toolKey, creditCost = null }) => {
  const { costFor, tools, loading } = usePricingCatalog();
  const taskKey = creditTaskKeyForTool(toolKey);
  const cost = useMemo(() => {
    const override = Number(creditCost);
    if (Number.isFinite(override) && override > 0) return override;
    const locked = uiCreditCostForTask(taskKey);
    if (locked) return locked;
    if (!loading && Array.isArray(tools) && tools.length > 0) {
      const fromApi = Number(costFor(taskKey));
      if (Number.isFinite(fromApi) && fromApi > 0) return fromApi;
    }
    return staticCostFor(taskKey);
  }, [costFor, creditCost, loading, taskKey, tools]);

  if (!cost) return null;

  return (
    <span
      className="abitp-done-credits"
      title={`${cost} credits per generation`}
      aria-hidden="true"
    >
      <CreditsIcon />
      {cost}
    </span>
  );
};

export default ToolPrepCreditsBadge;
